/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/24
 * @updateTime 2021/8/24
 * @decription 申请保全 =》 原告代理人
 */
// 模块预览组件
import ccPreviewModule from '@/components/common/preview-module/index.vue';
import {typeDlrlx,
    typeSfzjlx,
    typeXb} from "@/filters";
export default {
    name: 'Accuser',
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        ccPreviewModule
    },
    // 参数
    props: {
        // 依赖数据,依赖申请人列表数据
        dependData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    // 数据
    data() {
        return {
            // 数据列表
            data: [],
            // 转换后的数据
            transformData: []
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    created() {
        // 获取基本数据
        this.getData();
    },
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {
        /**
         * 请求数据
         * @param {Object} params 请求参数
         * */
        requestData(params) {
            return this.$axios.get('ssbq/api/ygdlrs', params);
        },
        /**
         * 获取行数据
         * @param {String} name 名称
         * @param {String|Number} value 值
         * @returns {Object}
         * */
        getRowData(name, value) {
            return {
                name: name,
                value: value
            };
        },

        /**
         * 获取转化之后的数据
         * @returns {Array} 转化之后的信息项数组
         * */
        getTransformData(data) {
            const _transformItemData = [];
            _transformItemData.push(this.getRowData('所属原告', data.cBqSqrName));
            _transformItemData.push(this.getRowData('代理人类型', data.cDlrlxName));
            _transformItemData.push(this.getRowData('代理人姓名', data.cDlrxm));
            _transformItemData.push(this.getRowData('性别', data.cDlrxbName));
            _transformItemData.push(this.getRowData('证件类型', data.cDlrzjlxName));
            _transformItemData.push(this.getRowData('证件号码', data.cDlrzjh));
            _transformItemData.push(this.getRowData('手机号码', data.cPhone));
            // 类型为1
            if (data.cDlrlx == 1) {
                _transformItemData.push(this.getRowData('执业证件号码', data.cDlrzjhm));
                _transformItemData.push(this.getRowData('代理人所在律所', data.cDlrszls));
            }
            _transformItemData.push(this.getRowData('固定电话', data.cGddh));
            return _transformItemData;
        },

        /**
         * 被申请人姓名
         * */
        getBsqrName(dataList, id) {
            let name = []
            dataList.map((item) => {
                if (id.indexOf(item.cId) > -1) {
                    name.push(item.cSqrlx == 1 ? item.cSqrxm : item.cQymc)
                }
            })
            return name.join(',')
        },

        /**
         * 获取数据
         * */
        getData() {
            // 请求申请人数据
            this.requestData({
                // 保全id
                bqid: sessionStorage.getItem('bqid')
            }).then(res => {
                const _data = res.data;
                const _transformData = [];
                _data.forEach((item) => {
                    // 申请人类型名称
                    item.cBqSqrName = this.getBsqrName(this.dependData, item.cBqSqrid);
                    // 代理人类型名称
                    item.cDlrlxName = typeDlrlx(item.cDlrlx);
                    // 性别名称
                    item.cDlrxbName = typeXb(item.cDlrxb);
                    // 证件类型名称
                    item.cDlrzjlxName = typeSfzjlx(item.cDlrzjlx);
                    // 转化之后的数据
                    _transformData.push(this.getTransformData(item));
                });
                // 数据赋值
                this.data = _data;
                // 转化之后的数据
                this.transformData = _transformData;
                // 加载完成
                this.$emit('loaded', this.data);
            });
        }
    }
};
